import React from 'react';
import styled from '@emotion/styled';
import { darken } from 'polished';

const Tag = styled.div`
  border-radius: 5px;
  padding: 0px 8px;
  margin: 0px 3px;
  border: 1px solid ${props => darken(0.3, props.color || props.theme.subtleText)};
  color: ${props => props.color || props.theme.subtleText};
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 1;
`;

const TagBoxRoot = styled.div({
  padding: `5px`,
  display: `flex`,
  justifyContent: `center`,
  width: `100%`
});

/*
  tags: [
    {
      text: "Mobile Legends Bang Bang"
      color: 'red',
    }
  ]
*/

const TagBox = ({ tags }) => {
  return (
    <>
      {tags && tags.length >= 1 && (
        <TagBoxRoot>
          {tags.map(({ text, color }) => {
            return <Tag color={color} key={text}>{text}</Tag>;
          })}
        </TagBoxRoot>
      )}
    </>
  );
};

export default TagBox;
